export enum PropertyStatusFilter {
  DEACTIVATED = 'DEACTIVATED',
  ACTIVE = 'ACTIVE',
  ERROR = 'ERROR',
  RESERVED = 'RESERVED'
}
